import { render, staticRenderFns } from "./TaskFilter.vue?vue&type=template&id=46ee151e&scoped=true&"
import script from "./TaskFilter.vue?vue&type=script&lang=ts&"
export * from "./TaskFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee151e",
  null
  
)

/* custom blocks */
import block0 from "./TaskFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports